import { enAPI } from '../config';
import { getHttpMethods, respond } from '../Components/Utils/httpMethods';
import { generatePoolObject } from '../Components/Utils/utils';

export const getRequestList = (app) => {
	return (dispatch, state) => {
		const http = getHttpMethods(dispatch, state);
		dispatch({ type: 'RESET_ERROR' });
		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });

		let body = {};
		http
			.post(enAPI + `${app}/getrequests`, body)
			.then((res) => {
				let reviewData = [];
				let items = res && res.data && res.data.Items;
				items && items.forEach(function (item) {
					var res = {
						requestedDate: item.requested_date,
						email: item.details.email,
						role: item.details.custom_Groups,
					};
					reviewData.push(res);
				});
				dispatch({ type: 'REQUEST_LIST', data: { requestList: reviewData, lastKey: res.data.LastEvaluatedKey } });
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('getRequestList', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const setReviewRequest = (list, lastKey) => {
	return (dispatch) =>{
		// dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: false } });
		dispatch({ type: 'REQUEST_LIST', data: { requestList: list, lastKey: lastKey } });
	}
}

export const getRequestDetails = (username) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });
		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });

		const http = getHttpMethods(dispatch, state);
		http
			.get(enAPI + `${app}/getrequest?email=${encodeURIComponent(username)}`)
			.then((res) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				let result = res.data;
				let reqDetails = result.requestDetails && result.requestDetails.details;
				dispatch({
					type: 'SET_REQUEST_DETAIL',
					data: { requestDetails: reqDetails, rejectedDetails: result.rejectedDetails },
				});
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('getRequestDetails', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const clearRequestDetails = () => {
	return (dispatch) =>
		dispatch({
			type: 'SET_REQUEST_DETAIL',
			data: { requestDetails: undefined, success: undefined, rejectedDetails: undefined },
		});
};

export const rejectRequest = (username, details, rejectedComments) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool,
			// displayName = store.account.user.name,
			fname = store.account.user.given_name,
			lName = store.account.user.family_name,
			LoggedInEmail = store.account.user.email;
		dispatch({ type: 'RESET_ERROR' });

		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });

		let rejectedDetails = {
			comments : rejectedComments,
			displayName : fname + ' ' + lName,
			email : LoggedInEmail
		}
		let body = {
			details,
			rejectedDetails
		}

		const http = getHttpMethods(dispatch, state);
		http
			.post(enAPI + `${app}/rejectrequest`, body)
			.then((res) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });

				if (res.data) {
					// dispatch({ type: 'UPDATE_STATUS', data: { success: "rejected" } });
					dispatch(deleteRequest(username, 'rejected'));
				}
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('rejectRequest', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const approveRequest = (username, details) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });

		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		let poolObject = generatePoolObject(details);
		let input = {
			name: 'email',
			value: details.email,
		};
		const http = getHttpMethods(dispatch, state);
		http
			.post(`${enAPI}${app}/searchusers`, input)
			.then((res) => {
				if (!res.data.Users.length > 0) {
					http
						.post(enAPI + `${app}/createuser`, poolObject)
						.then((res) => {
							dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
							if (res.data) {
								dispatch(deleteRequest(username, 'approved'));
							}
						})
						.catch((err) => {
							dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
							respond('approveRequest', err, dispatch);
							console.log('error:', err);
						});
				}
				else {
					dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
					respond('userExists', { message: 'User with given email already exists' }, dispatch);
				}
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('approveRequest', err, dispatch);
				console.log('error:', err);
			})
	};
};

export const deleteRequest = (username, action) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });

		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		const http = getHttpMethods(dispatch, state);
		http
			.delete(enAPI + `${app}/deleterequest?email=${encodeURIComponent(username)}`)
			.then((res) => {
				let successMessage = username + ' is ' + action;
				if (res.data) {
					dispatch({ type: 'UPDATE_STATUS', data: { success: successMessage } });
				}
				dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: true } });
			})
			.then((res)=>{
				dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: false } });
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('deleteRequest', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const fetchComplete = (load) =>{
	return (dispatch, state) => {
		dispatch({ type: 'SET_LOADING', data: { isLoading: load } });
	}
}

export const errorWhileFetch = (err) => {
	return (dispatch, state) => {
	  dispatch({
		type: 'SET_ERROR',
		data: { error_obj: { errorPath: err } }
	  });
	}
}

export const deleteProcess = () => {
	return (dispatch, state) => {
	  dispatch({
		type: 'DELETE_REQUEST',
		data: { deleting: false }
	  });
	}
}

export const getRejectedList = (attribute_name,	attribute_value	) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		const http = getHttpMethods(dispatch, state);
		dispatch({ type: 'RESET_ERROR' });
		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		let input = attribute_name === 'email' ? {"email": attribute_value }  : {"custom_company": attribute_value}

		http
			.post(enAPI+`${app}/getrejectedrequests`, input)
			.then((res) => {
				let list = [];
				let items = res && res.data && res.data.Items;
				items && items.forEach(function (item) {
					
					var res = {
						email : item.email_id,
						rejected_date: item.rejected_date,
						company: item.custom_company
					};
					list.push(res);
				});
				let lastKey = {
					lastEvaluatedKey : res.data.LastEvaluatedKey
				}
				dispatch({ type: 'REJECTED_LIST', data: { rejectedList: list, lastKey: lastKey } });
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('getRejectedList', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const getRejectedInfo = (email, rejectedDate) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });
		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });

		let input = {
			email,
			rejectedDate,
		};
		const http = getHttpMethods(dispatch, state);
		http
			.post(enAPI+`${app}/getrejectedrequest`, input)
			.then((res) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				let result = res.data;
				dispatch({
					type: 'SET_REJECTED_INFO',
					data: { rejectedInfo: result },
				});
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('getRejectedInfo', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const approveRejectedRequest = (details, rejectedDate, attributeName, attributeValue) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });

		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		let poolObject = generatePoolObject(details);
		let input = {
			name: 'email',
			value: details.email,
		};
		const http = getHttpMethods(dispatch, state);
		http
			.post(`${enAPI}${app}/searchusers`, input)
			.then((res) => {
				if (!res.data.Users.length > 0) {
					http
						.post(enAPI + `${app}/createuser`, poolObject)
						.then((res) => {
							dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
							if (res.data) {
								dispatch(deleteRejectedRequest(details.email, rejectedDate, attributeName, attributeValue))
							}
						})
						.catch((err) => {
							dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
							respond('approveRejectedRequest', err, dispatch);
							console.log('error:', err);
						});
				}
				else {
					// dispatch(deleteRejectedRequest(details.email, rejectedDate, attributeName, attributeValue))
					dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
					respond('userExists', { message: 'User with given email already exists' }, dispatch);
				}
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('approveRejectedRequest', err, dispatch);
				console.log('error:', err);
			})
	};
};

export const deleteRejectedRequest = (email, rejectedDate) => {
	return (dispatch, state) => {
		let store = state(),
			app = store.pool.userPool;
		dispatch({ type: 'RESET_ERROR' });

		dispatch({ type: 'SET_LOADING', data: { isLoading: true } });
		let input = {
			"email" :email,
			"rejected_date" : rejectedDate,
		};
		const http = getHttpMethods(dispatch, state);
		http
			.post(enAPI+`${app}/deleterejecthistory`, input)
			.then((res) => {
				let successMessage = email + ' is  approved';
				dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: true } });

				if (res.data) {
					dispatch({ type: 'UPDATE_STATUS', data: { success: successMessage } });
				}
			})
			.then(()=>{
				dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: false } });
			})
			.catch((err) => {
				dispatch({ type: 'SET_LOADING', data: { isLoading: false } });
				respond('deleteRejectedRequest', err, dispatch);
				console.log('error:', err);
			});
	};
};

export const clearRejectedInfo = () => {
	return (dispatch) =>
		dispatch({
			type: 'SET_REJECTED_INFO',
			data: { rejectedInfo: undefined, success: undefined },
		});
};

// export const setDeleteStatus = () => {
// 	return (dispatch) =>
// 		dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: false } });
// }

export const setRejectedList = (list, lastKey) => {
	return (dispatch) =>{
		// dispatch({ type: 'DELETE_REQUEST_STATUS', data: { deleted_status: false } });
		dispatch({ type: 'RESET_REJECTED_LIST', data: { rejectedList: list, lastKey: {lastEvaluatedKey : lastKey} } });
	}
}